import { Grid } from '@mui/material';
import { FC, ReactNode } from 'react';

export type FieldGridContainerProps = {
  children: ReactNode;
  dataTestId?: string;
  isFullWidth?: boolean;
  responsive?: {
    xs?: number;
    sm?: number;
    md?: number;
    lg?: number;
    xl?: number;
  };
};

/**
 * Generic component to render a consistent form grid component for responsiveness
 * @param children - The content to render inside the grid item
 * @param dataTestId - Optional test ID for testing
 * @param isFullWidth - If true, item takes full width on all breakpoints
 * @param responsive - Optional custom responsive breakpoint values (xs, sm, md, lg, xl)
 * @returns Renders a uniform react spacing for grid items of textfield type in a responsive way
 */
const FieldGridContainer: FC<FieldGridContainerProps> = ({
  children,
  dataTestId,
  isFullWidth = false,
  responsive,
}) => {
  // Default responsive props
  const defaultProps = {
    xs: 12,
    sm: isFullWidth ? 12 : 6,
    md: isFullWidth ? 12 : 4,
    lg: isFullWidth ? 12 : 3,
  };

  // Use custom responsive props if provided, otherwise use defaults
  const gridProps = responsive || defaultProps;

  return (
    <Grid item {...gridProps} data-testid={dataTestId}>
      {children}
    </Grid>
  );
};

export default FieldGridContainer;
